import { Paper, Typography } from "@mui/material"
import ProcurementContainer from "../../procurement/containers/ProcurementContainer"
import PaymentsHistoryList from "../lists/paymentsHistoryList"
import React from "react";

const PaymentsHistoryPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Payments History
      </Typography>
      
      <Paper sx={{my: 5}}>
        <PaymentsHistoryList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default PaymentsHistoryPage
